import { Component, Input, OnInit } from "@angular/core";
import { CloudbedsService } from "@app/services/cloudbeds.service";
import { ModalController } from "@ionic/angular";
import { AlertService } from "@app/shared/services/alert.service";
import { CodebaseTranslateService } from "@app/services/codebase-translate.service";
import { Storage } from "@ionic/storage";
import { UsersApiService } from "@app/core/users-api/users-api.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SecureUserRepositoryService } from "@app/core/users-api/secure-user-repository.service";
import { SharedConstantsService } from "@app/shared/services/shared-constants.service";
import country_codes from "../../../../assets/countrycodes.json";
import { Router } from "@angular/router";
import { ModalChargesComponent } from "../modal-charges/modal-charges.component";
import { environment } from "@env/environment";
import { PopupPrearrivalComponent } from "@app/codebase/popup-prearrival/popup-prearrival.component";

@Component({
  selector: "app-modal-reservation",
  templateUrl: "./modal-reservation.component.html",
  styleUrls: ["./modal-reservation.component.scss"],
})
export class ModalReservationComponent implements OnInit {
  reservationNumber: string = "";
  title: string;
  phone: string;
  public environment = environment;
  user: any;
  countries = country_codes;
  public reservationForm!: FormGroup;
  constructor(
    private modalCtrlr: ModalController,
    private alertService: AlertService,
    public storage: Storage,
    private fb: FormBuilder,
    private userRepository: SecureUserRepositoryService,
    private usersApi: UsersApiService,
    private sharedConstants: SharedConstantsService,
    public translateService: CodebaseTranslateService,
    private router: Router,
    private cloudbedsService: CloudbedsService
  ) {}

  async ngOnInit() {
    if (!environment.demoMode){
      this.user = await this.usersApi.getUser();
      console.log(this.user);
    }

      // this.showPreArrival();
    this.reservationForm = this.fb.group({
      reservation: ["", [Validators.required]],
      firstName: [!environment.demoMode ? await this.userRepository.getAdditionalField(
        this.sharedConstants.apFullName
      ) : 'Douglas Ralston', [Validators.required, Validators.minLength(2)]],
      email: [!environment.demoMode ? this.user.Email : 'dr@trueomni.com', [Validators.required, Validators.minLength(2)]],
      phoneCode: [""],
      phone: ["", [Validators.required, Validators.minLength(2)]],
    });
    this.reservationNumber = !environment.demoMode ? await this.storage.get("reservation")  : '1781709293016';
    console.log(this.reservationNumber)
    this.reservationForm.controls.reservation.patchValue(this.reservationNumber);
    this.reservationForm.controls.reservation.updateValueAndValidity();
    this.phone = !environment.demoMode ? await this.userRepository.getAdditionalField(
      this.sharedConstants.apPhone
    ) : '0532495784';
    console.log(this.phone)
    if (this.phone) {
      // this.reservationForm.controls.phoneCode.patchValue(this.phone.split("-")[0]);
      this.reservationForm.controls.phone.patchValue(this.phone);
      // this.reservationForm.controls.phoneCode.updateValueAndValidity()
      this.reservationForm.controls.phone.updateValueAndValidity()
    }
    // this.showsuccessConfirmation();

  }

  async find() {
    if (environment.demoMode) {
      this.router.navigate(["/welcome-checkin/details-checkin"]);
      return;
    };
    var body = {};
    if (this.phone){
      body['phone'] = `${this.phone}`
      body['reservationId'] = ``
    }else{
      body['reservationId'] = `${this.reservationNumber}`
    }
    this.cloudbedsService
      .findReservation(body)
      .then((res:any) => {
        console.log(res.data)
        this.showsuccessConfirmation();
        // this.router.navigate(["/welcome-checkin/details-checkin"]);
        // this.modalCtrlr.dismiss({ result: res });
      })
      .catch((err) => {
        this.alertService.presentInfoAlert(
          null,
          this.translateService.instant("ALERTS.LBL_RESERVATIONNOTFOUND"),
          [
            {
              text: this.translateService.instant(
                "ALERTS.LBL_RESERVATIONNOTFOUND"
              ),
            },
          ]
        );
        window.history.back();
      });
  }

  async showsuccessConfirmation() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'charges-modal',
      component:  ModalChargesComponent,
      componentProps: {
        title: '',
        buttons: [
          {
            title: 'Dismiss',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    // this.router.navigate(["tabs/checkin/payment"]);
    // if (data && data.result) {
    //   this.modalCtrlr.dismiss({ result: null });
    //   return '';
    // }
  }

  async showPreArrival() {
    const modal = await this.modalCtrlr.create({
      cssClass: 'popuparrival-modal',
      component:  PopupPrearrivalComponent,
      componentProps: {
        title: 'PRE ARRIVAL SCAN ID',
        image: 'assets/cico/home_logo.png',
        text: 'Save time at the lobby. Scan your ID now for a faster Check-In experience.',
        buttons: [
          {
            title: 'NO, THANK YOU',
            value: 'cancel'
          },
          {
            title: 'CONTINUE',
            value: 'cancel'
          }
        ]
      }
    });
    await modal.present().then( result => { } );
    //await modal.present();
    const { data } = await modal.onDidDismiss();
    // this.router.navigate(["tabs/checkin/payment"]);
    // if (data && data.result) {
    //   this.modalCtrlr.dismiss({ result: null });
    //   return '';
    // }
  }

  goBack() {
    // this.modalCtrlr.dismiss();
    window.history.back();
  }
}
